import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { doLogin } from '../actions'
import { GoogleButton as GoogleButtonComponent } from '../../../Components/GoogleButton';

const mapStateToProps = (state, params) => {
  return {
    ...state.googleAuth,
    userDefaults: state.login.userDefaults,
    text:         state.localization.dictionary.login.loginGoogle
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    doLogin: data => dispatch(doLogin(data))
  }
}

class GoogleButton extends React.Component {
  static propTypes = {
    doLogin:      PropTypes.func,
    onSuccess:    PropTypes.func,
    onError:      PropTypes.func,
    clientId:     PropTypes.string,
    userDefaults: PropTypes.object,

    // Server responses saved into state
    response:     PropTypes.object,
    error:        PropTypes.object,
  }

  doLogin = (response) => {
    const profile = response.profileObj

    // TODO: Consider putting this mapping in the action
    this.props.doLogin({
      ...this.props.userDefaults,
      id_token:        response.tokenId,
      sso_accesstoken: response.accessToken,
      email:           profile.email,
      sso_firstname:   profile.givenName,
      sso_lastname:    profile.familyName,
      sso_avatar:      profile.imageUrl,

      // Google doesnt provide but PHP expects the key
      sso_gender: null,
    })
  }

  /**
   * Trigger the apporpriate events based on the current state.
   */
  componentWillReceiveProps(props) {
    const { onSuccess, onError, response, error } = props

    onSuccess && response && onSuccess(response)
    onError && error && onError(error)
  }

  render() {
    const { doLogin, onError, text, clientId } = this.props

    return (
      <GoogleButtonComponent
        onSuccess={ this.doLogin }
        onError={ onError }
        children={ text }
        clientId={ clientId } />
    )
  }
}

const GoogleButtonConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleButton)


export {
  GoogleButtonConnected as GoogleButton
}



// WEBPACK FOOTER //
// ./client/Modules/AuthGoogle/containers/GoogleButton.js